import React from "react";
import { FaCode, FaBrain, FaUsersCog, FaRocket } from "react-icons/fa";

export function ServiceFeatures() {
  const features = [
    {
      name: ".NET  & Blazor Integration",
      description: "Expert implementation of AI systems using the latest .NET technologies, including Blazor for modern web interfaces and Entity Framework for data management.",
      icon: FaCode,
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      name: "Semantic Kernel Solutions",
      description: "Specialized in Microsoft's Semantic Kernel framework for building sophisticated AI applications that can reason, plan, and execute complex tasks.",
      icon: FaBrain,
      gradient: "from-purple-500 to-pink-500",
    },
    {
      name: "Team Training & Development",
      description: "Comprehensive training programs to build your internal AI capabilities, ensuring your team can maintain and extend your AI systems.",
      icon: FaUsersCog,
      gradient: "from-orange-500 to-red-500",
    },
    {
      name: "End-to-End Implementation",
      description: "Full project implementation with thorough documentation, tools, and knowledge transfer to ensure long-term success.",
      icon: FaRocket,
      gradient: "from-green-500 to-teal-500",
    },
  ];

  return (
    <section className="relative bg-gray-900 py-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ 
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23FFFFFF\' fill-opacity=\'0.1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          backgroundSize: '30px 30px'
        }} />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Comprehensive AI Integration Services
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-300">
            We specialize in building intelligent systems that integrate seamlessly with your existing infrastructure.
          </p>
        </div>

        <div className="mt-20">
          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-2">
            {features.map((feature) => (
              <div key={feature.name} className="relative overflow-hidden rounded-2xl bg-gray-800 p-8">
                <div className={`absolute -right-8 -top-8 h-32 w-32 rounded-full bg-gradient-to-br ${feature.gradient} opacity-20 blur-2xl`} />
                <div className="relative flex items-start gap-6">
                  <div className={`flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br ${feature.gradient}`}>
                    <feature.icon className="h-8 w-8 text-white" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white">{feature.name}</h3>
                    <p className="mt-2 text-gray-300">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
